import {
  Text as BlueprintText,
  TextProps as BlueprintTextProps,
} from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

export type BodyProps = BlueprintTextProps & {
  'data-testid'?: never;
  divRef?: React.RefObject<HTMLDivElement>;
  size: 'lg' | 'md' | 'sm' | 'xs';
  weight?: 'regular' | 'semibold' | 'light';
  testId?: string;
};

export const Body: React.VFC<BodyProps> = ({
  children,
  className,
  divRef,
  size,
  testId,
  weight = 'regular',
  ...props
}) => (
  <div
    ref={divRef}
    className={classNames(
      className,
      'vb-typography',
      `vb-typography--${weight}`,
      'vb-typography-body',
      `vb-typography-body--${size}`
    )}
    data-heap-redact-attributes="title"
    data-testid={testId}
  >
    <BlueprintText
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </BlueprintText>
  </div>
);
